<!-- <app-header-dashboard></app-header-dashboard>
<main class="main">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="dashbox">
          <div class="dashbox_title_flex">
            <h2 class="dashbox_title">Wallet Balance</h2>
          </div>
          <div class="wallet_balance_overview">
            <div>
              <label>Total Crypto Balance</label>
              <h3 [countUp]="cryptoBalance" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div>
            <div>
              <label>Total Balance</label>
              <h3 [countUp]="totalBalance" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div>
            <div>
              <label>Total INR Balance</label>
              <h3 [countUp]="inrBalance" [reanimateOnClick]="false" [options]="inrOptions"></h3>
              <div class="fiat_wallet_btns">
                <a [ngClass]="{ disabled: inrCurrency?.status !== 'active' || inrCurrency?.depositStatus !== 'active' }"
                  routerLink="/deposit-fiat" class="deposit_btn">Deposit</a>
                <a [ngClass]="{ disabled: inrCurrency?.status !== 'active' || inrCurrency?.withdrawStatus !== 'active' }"
                  routerLink="/withdraw-fiat" class="withdraw_btn">Withdraw</a>
              </div>
            </div>
          </div>
        </div>

        <div class="dashbox">
          <div class="dashbox_title_flex">
            <h2 class="dashbox_title">Assets Overview</h2>
            <div class="form-group ms-auto" style="min-width: 120px;">
              <select class="form-select" (change)="onCurrencyTypeChange($event)">
                <option value="INR">INR</option>
                <option value="USDT">USDT</option>
              </select>
            </div>

            <div class="primary_inp_grp">

              <input type="text" class="form-control" placeholder="Search coin" [(ngModel)]="searchText"
                (ngModelChange)="applyFilter()" />
              <img src="assets/images/search_icon.png" class="img-fluid" alt="Search" />
            </div>

          </div>
          <div class="table-responsive">
            <div class="d-flex justify-content-center mb-5" *ngIf="!loader; else tabledata">
              <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
              <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
              <span class="text-primary  -grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            </div>

            <ng-template #tabledata>
              <table class="table primary_table">
                <thead>
                  <tr>
                    <th>Asset</th>
                    <th>Balance</th>
                    <th>Invested</th>
                    <th>Current Price</th>
                    <th>PnL Value</th>
                    <th>PnL (%)</th>
                    <th>Status</th>
                    <th>Deposit</th>
                    <th>Withdraw</th>
                    <th>Traid</th>

                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let item of filteredPairList | textFilter: searchPair : 'item.coin' | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage }">
                    <td>
                      <img *ngIf="item.image" [src]="item.image" alt="{{ item.coin }}" width="24" height="24"
                        style="margin-right: 8px; vertical-align: middle;" />
                      {{ item.firstCurrencySymbol }}
                    </td>

                    <td>{{ item.totalQuantity }}</td>
                    <td>{{ item.investment }}</td>
                    <td>{{ item.currentPrice }}</td>

                    <td>
                      <span [ngClass]="{
                          'text-success': item.pnl > 0,
                          'text-danger': item.pnl < 0,
                          'text-muted': item.pnl == 0
                        }">
                        {{ item.pnl }}
                      </span>
                    </td>

                    <td>
                      <span [ngClass]="{
                          'text-success': item.pnlPercentage.startsWith('+'),
                          'text-danger': item.pnlPercentage.startsWith('-'),
                          'text-muted': item.pnlPercentage === '0%'
                        }">
                        {{ item.pnlPercentage }}
                      </span>
                    </td>

                    <td>
                      <ng-container [ngSwitch]="item.actionStatus">
                        <span *ngSwitchCase="'sell'" class="badge bg-success" style="cursor: pointer"
                          (click)="goToTrade(item.firstCurrencySymbol, item.secondCurrencySymbol)">
                          {{ item.actionStatus | titlecase }}
                        </span>

                        <span *ngSwitchCase="'wait'" class="badge bg-warning text-dark">
                          <i class="fa-solid fa-clock-rotate-left"></i> Wait
                        </span>

                        <span *ngSwitchDefault class="badge bg-secondary">
                          {{ item.actionStatus | titlecase }}
                        </span>
                      </ng-container>
                    </td>

                    <td>
                      <a [ngClass]="{ disabled: item.depositStatus !== 'active' }"
                        [routerLink]="'/deposit-crypto/' + item.coin" class="green_txt">
                        Deposit
                      </a>



                    </td>
                    <td> <a [ngClass]="{ disabled: item.withdrawStatus !== 'active' }"
                        [routerLink]="'/withdraw-crypto/' + item.coin" class="red_txt">
                        Withdraw
                      </a></td>
                    <td>
                      <a *ngIf="item.hasTradePair" href="{{
                        'spot/' +
                          item.hasTradePair.firstCurrencySymbol +
                          '_' +
                          item.hasTradePair.secondCurrencySymbol
                      }}
                      " class="blue_txt">Trade</a>
                    </td>
              </table>
              <div class="pagination-container text-end mt-3">
                <pagination-controls (pageChange)="currentPage = $event"></pagination-controls>
              </div>
            </ng-template>

          </div>

        </div>
    </div>
  </div>
</main> -->


<app-header-dashboard></app-header-dashboard>
<main class="main">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="dashbox">
          <div class="dashbox_title_flex">
            <h2 class="dashbox_title">Wallet Balance</h2>
          </div>
          <div class="wallet_balance_overview">
            <!-- <div>
              <label>Crypto Balance</label>
              <h3 [countUp]="cryptoBalance" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div> -->
            <!-- <div>
              <label>Total Balance</label>
              <h3 [countUp]="totalBalance" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div> -->
    <div>
              <label>INR Balance</label>
              <h3 [countUp]="inrBalance" [reanimateOnClick]="false" [options]="inrOptions"></h3>
              <div class="fiat_wallet_btns">
                <a [ngClass]="{ disabled: inrCurrency?.status !== 'active' || inrCurrency?.depositStatus !== 'active' }"
                  routerLink="/deposit-fiat" class="deposit_btn">Deposit</a>
                <a [ngClass]="{ disabled: inrCurrency?.status !== 'active' || inrCurrency?.withdrawStatus !== 'active' }"
                  routerLink="/withdraw-fiat" class="withdraw_btn">Withdraw</a>
              </div>
            </div>


            <div>
              <label>Crypto Balance</label>
              <h3 [countUp]="cryptoBalance" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div>
            <div>
              <label>Total Balance</label>
              <h3 [countUp]="totalBalance" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div>

           

          </div>
          <!-- <div class="wallet_balance_overview">
            <div>
              <label>Bot Profit</label>
              <h3 [countUp]="BotProfit" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div>
            <div>
              <label>Open Order Value</label>
              <h3 [countUp]="OpenOrderValue" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div>
            <div>
              <label>Subscrtiption</label>
              <h3 [countUp]="Subscrtiption" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
            </div>
            </div>
            <div class="wallet_balance_overview">
        
              <div>
                <label>Total Deposit</label>
                <h3 [countUp]="totDeposit" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
              </div>  
               <div>
                <label>Total Withdraw</label>
                <h3 [countUp]="totWithdraw" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
              </div>  
               <div>
                <label> Total PNL </label>
                <h3 [countUp]="BotProfit" [reanimateOnClick]="false" [options]="usdtOptions"></h3>
              </div>
              </div> -->
        </div>
        <div class="dashbox">
          <div class="dashbox_title_flex">
            <h2 class="dashbox_title">Assets Overview</h2>
            <div class="primary_inp_grp">
              <input placeholder="Search Coin" type="text" class="primary_inp" (input)="handleSearch($event)"
                alphaNumeric />
              <img src="assets/images/search_icon.png" class="img-fluid" alt="Search" />
            </div>

          </div>
          <div class="table-responsive">
            <div class="d-flex justify-content-center mb-5" *ngIf="!loader; else tabledata">
              <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
              <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
              <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            </div>
            <ng-template #tabledata>
              <table class="table primary_table">
                <thead>
                  <tr>
                    <th>Assets</th>
                    <th>Amount</th>
                    <th>INR</th>
                    <th>USDT</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of Assets | textFilter: 'coin': search: 'wallet'">
                    <td>
                      <div class="d-flex align-items-center">
                        <img src="{{ item.currency?.image }}" alt="{{ item.wallet?.coin }}" alt="Crypto"
                          class="img-fluid history_table_icon" />

                        <span>{{ item.wallet?.coin }} /
                          <span class="blue_txt">{{
                            item.currency?.name
                            }}</span></span>
                      </div>
                    </td>
                    <td>{{ toFixedDown(item.wallet.spotBal, item?.currency?.decimals) }}</td>
                    <td>
                      {{
                      item.wallet?.coin == "INR" ? toFixedDown(item.wallet.spotBal, item?.currency?.decimals) :
                      item.inrPrice
                      ? toFixedDown(item.wallet.spotBal * item.inrPrice, item?.currency?.decimals)
                      : '0.00'
                      }}
                    </td>
                    <td>
                      {{
                      item.wallet?.coin == "USDT" ? toFixedDown(item.wallet.spotBal, item?.currency?.decimals) :
                      item.usdtPrice
                      ? toFixedDown(item.wallet.spotBal * item.usdtPrice, item?.currency?.decimals)
                      : '0.00'
                      }}
                    </td>
                    <td>
                      <div class="wallet_asset_links">
                        <a [ngClass]="{ disabled: item?.currency?.depositStatus !== 'active' }"
                          routerLink="/deposit-{{item?.currency?.type == 'fiat' ? 'fiat': 'crypto'}}/{{ item.wallet?.coin }}"
                          class="green_txt">Deposit</a>

                        <a [ngClass]="{ disabled: item?.currency?.withdrawStatus !== 'active' }"
                          routerLink="/withdraw-{{item?.currency?.type == 'fiat' ? 'fiat': 'crypto'}}/{{ item.wallet?.coin }}"
                          class="red_txt">Withdraw</a>

                        <a *ngIf="item.hasTradePair" href="{{
                          'spot/' +
                            item.hasTradePair.firstCurrencySymbol +
                            '_' +
                            item.hasTradePair.secondCurrencySymbol
                        }}
                        " class="blue_txt">Trade</a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>